// taiwan.ts
// CONTRACT:P1-CANONICAL-ENVELOPE.1.0
//
// COP — the WIRED multi-INT "Taiwan Strait" theater. A thin wrapper that binds
// ./scenario-taiwan.json to the generic theater loader (./theaters.ts), mirroring
// hormuz.ts's public surface (startTaiwanScenario / taiwanEnvelopes). Every record
// carries REAL corpus markings and is published as a CanonicalEnvelope onto the
// SAME bus → LOCAL PDP (I4) → render path, so the clearance filter bites on the
// WHOLE picture (permit → show / deny → absent).

import type { EnvelopeBus } from "../host/envelopeBus.ts";
import type { CanonicalEnvelope } from "../../../../packages/schema/ts/envelope.ts";
import {
  startTheaterScenario,
  theaterEnvelopes,
  type TheaterDef,
  type TheaterHandle,
  type TheaterRecord,
} from "./theaters.ts";
import taiwanData from "./scenario-taiwan.json";

/** The Taiwan Strait theater definition (the corpus + its stamped metadata). */
export const TAIWAN_THEATER: TheaterDef = {
  id: "taiwan",
  label: "Taiwan Strait",
  records: taiwanData as unknown as TheaterRecord[],
};

export interface TaiwanHandle extends TheaterHandle {}

/** Project the Taiwan corpus to envelopes once (static snapshot / tests). */
export function taiwanEnvelopes(): CanonicalEnvelope[] {
  return theaterEnvelopes(TAIWAN_THEATER);
}

/** Start the live Taiwan Strait picture (emit-once + per-tick re-emit). */
export function startTaiwanScenario(bus: EnvelopeBus, tickMs = 1_000): TaiwanHandle {
  return startTheaterScenario(TAIWAN_THEATER, bus, tickMs);
}
